"use client";

import { usePathname } from "next/navigation";

import { jsonLdSafe } from "@/lib/json-ld";
import { buildDocJsonLd } from "@/lib/docs-json-ld";

/**
 * Renders per-page TechArticle + BreadcrumbList JSON-LD for the current
 * docs route. Lives in `docs/layout.tsx` (a Server Component with no
 * access to the current pathname) rather than each `page.mdx`, mirroring
 * how `DocsShell` already derives the visible breadcrumb from
 * `usePathname()`. See issue #1250.
 */
export function DocsJsonLd() {
  const pathname = usePathname();
  const result = buildDocJsonLd(pathname);
  if (!result) return null;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdSafe(result.techArticle) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdSafe(result.breadcrumb) }}
      />
    </>
  );
}
